const BRUNNSTROM_STAGES = {
  stage1: { title: "Flaccidity", description: "No mov't on either a reflex or voluntary basis" },
  stage2: {
    title: "Basic limb synergies",
    description:
      "Basic limb synergies or some of their components may appear; Spasticity begins to develop; Evident in muscle groups that dominate synergy patterns (elbow flexors and knee extensors)",
  },
  stage3: {
    title: "Gain voluntary control",
    description:
      "Gain voluntary control of mov't synergies, but full range of synergy components does not necessarily develop; Severe spasticity, reaches its peak; Semivoluntary able to initiate mov't but unable to control the form of resulting mov't",
  },
  stage4: {
    title: "Movement combinations",
    description:
      "Movement combinations that do not follow the paths of the basic limb synergies are mastered first with difficulty then with increasing ease; Spasticity begins to decline",
  },
  stage5: {
    title: "Recovery continues",
    description:
      "Recovery continues, more difficult mov't combination are mastered as basic limb synergies lose their dominance over motor acts; Spasticity continues to decline",
  },
  stage6: {
    title: "Individual joint movements",
    description:
      "Individual joint movements become possible and coordination approaches normalcy; Spasticity disappears; Pt. becomes capable of a full spectrum of movement patterns",
  },
  stage7: {
    title: "Last recovery stage",
    description: "Last recovery stage; Normal motor function is restored",
  },
};

const Brunnstrom = () => {
  return (
    <div className="brunnstrom-stages">
      {Object.entries(BRUNNSTROM_STAGES).map(([stage, info]) => (
        <div key={stage} className="brunnstrom-stage">
          <div className="stage-checkbox">
            <label className="stage-number">{stage.replace('stage', 'Stage ')}</label>
          </div>
          <div className="stage-content">
            <div className="stage-title">{info.title}</div>
            <div className="stage-description">{info.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Brunnstrom;
